import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import { ThemeProvider } from './context/ThemeContext';
import Login from './components/Login/Login';
import Dashboard from './components/Layout/Dashboard';
import Home from './components/Dashboard/Home';
import ProjectList from './components/Projects/ProjectList';
import ProjectForm from './components/Projects/ProjectForm';
import GalleryList from './components/Gallery/GalleryList';
import ServiceList from './components/Services/ServiceList';
import ServiceForm from './components/Services/ServiceForm';
import InquiryList from './components/Inquiries/InquiryList';
import SiteSettings from './components/Settings/SiteSettings';
import ReviewsManager from './components/Reviews/ReviewsManager';
import PackagesManager from './components/Packages/PackagesManager';
import ProtectedRoute from './components/ProtectedRoute';

function App() {
  return (
    <ThemeProvider>
    <Router>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route
          path="/"
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          }
        >
          <Route index element={<Home />} />
          <Route path="projects" element={<ProjectList />} />
          <Route path="projects/new" element={<ProjectForm />} />
          <Route path="projects/:id" element={<ProjectForm />} />
          <Route path="gallery" element={<GalleryList />} />
          <Route path="services" element={<ServiceList />} />
          <Route path="services/new" element={<ServiceForm />} />
          <Route path="services/edit/:id" element={<ServiceForm />} />
          <Route path="inquiries" element={<InquiryList />} />
          <Route path="reviews" element={<ReviewsManager />} />
          <Route path="packages" element={<PackagesManager />} />
          <Route path="settings" element={<SiteSettings />} />
        </Route>
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="dark"
      />
    </Router>
    </ThemeProvider>
  );
}

export default App;
